import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './hooks/useTranslation';
import Home from './components/Home';
import TypingScreen from './components/typing/TypingScreen';
import SettingsScreen from './components/onboarding/SettingsScreen';
import './styles/global.css';

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/typing/:setId" element={<TypingScreen />} />
            <Route path="/settings" element={<SettingsScreen />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;